import { Product } from "gql/generated";
import _ from "lodash";
import { useBookerContext } from "widgets/booker/contexts";

export const useAddOns = (productId: string | null) => {
  const { booker, loading, error, isCatalog } = useBookerContext();

  // Catalog bookers offer order-level add-ons from the first bundle; products
  // already browsable in the catalog are never repeated as add-ons.
  if (isCatalog) {
    const catalogProductIds = new Set(
      (booker?.bundles ?? []).map(bundle => bundle?.product?._id),
    );
    const upsells = _.compact(booker?.bundles?.[0]?.upsells) as Product[];
    return {
      loading,
      error,
      addOns: _.uniqBy(
        upsells.filter(p => !catalogProductIds.has(p._id)),
        "_id",
      ),
    };
  }

  const mainProductBundle = booker?.bundles.find(
    (bundle) => bundle?.product?._id === productId,
  );

  return {
    loading,
    error,
    addOns: (_.compact(mainProductBundle?.upsells) ?? []) as Product[],
  };
};
